import React from "react";
import { Box, styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const Row = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: theme.spacing(2),
}));

interface Props {
  data: {
    name: string;
    cost: number;
    logo?: React.ReactNode;
  }[];
}

export const ProductInfoTable = ({ data }: Props) => {
  const { t } = useTranslation();
  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="body1" mb={4}>
        {t("recommender.compareView.fees.cost")}
      </Typography>
      <Box display="flex" flexDirection="column">
        <Row mb={3.5}>
          <Typography variant="overline2" color="textSecondary">
            {t("recommender.compareView.fees.productName")}
          </Typography>
          <Typography variant="overline2" color="textSecondary">
            {t("recommender.compareView.fees.ongoingFee")}
          </Typography>
        </Row>
        <Box display="flex" flexDirection="column" gap={3.5}>
          {data.map((item) => (
            <Row key={item.name}>
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                gap={2}
              >
                {item.logo}
                <Typography variant="body2" color="textSecondary">
                  {item.name}
                </Typography>
              </Box>
              <Typography variant="subtitle2">{item.cost}%</Typography>
            </Row>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
